export default __webpack_public_path__ + "static/media/Header-16.b56b59ac.jpg";